import { useEffect, useMemo } from 'react';
import { useAnalyticsEvents } from '@atlassian/jira-product-analytics-bridge';
import { getRegistryData, hasChildren } from '../../common/utils';
import { useCommandPaletteUsePerformModeState } from '../command-palette';

export const usePerformMode = () => {
	const { createAnalyticsEvent } = useAnalyticsEvents();

	const [
		{ commands, search, expandedCommand, childResult, registry, activeRegistry },
		{ executeCommand },
	] = useCommandPaletteUsePerformModeState();

	const hasLoadChildren = hasChildren(expandedCommand);

	const selectedCommands = useMemo(
		() => (hasLoadChildren ? childResult?.commands || [] : commands),
		[hasLoadChildren, childResult?.commands, commands],
	);
	const foundCommand = useMemo(
		() => selectedCommands.find((command) => command.mode && command.mode === search),
		[search, selectedCommands],
	);

	useEffect(() => {
		if (foundCommand)
			executeCommand(foundCommand, {
				method: 'mode',
				createAnalyticsEvent,
				attributes: getRegistryData(registry, activeRegistry, foundCommand.id),
			});
	}, [executeCommand, createAnalyticsEvent, registry, activeRegistry, foundCommand]);
};
